// Example: Product.jsx
function Product() {
  return <h1 className="text-3xl font-bold text-center mt-10">Product Page</h1>;
}
export default Product;